import KeywordHighlight from './KeywordHighlight'
import TabList from './TabList'
import TabPanel from './TabPanel'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class OverlayImageTabs extends PureComponent {
  static propTypes = {
    description: PropTypes.string,
    searchHighlights: PropTypes.array
  }

  static defaultProps = {
    searchHighlights: []
  }

  render() {
    const { description, searchHighlights } = this.props
    const tokens = searchHighlights.reduce((memo, highlight) => {
      return memo.concat(highlight.tokens)
    }, [])

    return (
      <TabList>
        <TabPanel title="Description">
          <div className="transcript-viewer">
            <KeywordHighlight text={description} tokens={tokens}>
              <span className="grey-reg-i">
                {I18n.t('No description provided')}
              </span>
            </KeywordHighlight>
          </div>
        </TabPanel>
      </TabList>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayImageTabs.js